// extracted by mini-css-extract-plugin
export var p = "mobile-module--p--744a3";